import React, { createContext, useContext, ReactNode } from "react";

interface HelpPopupContextType {
  setExternalLink: (linkElement: ReactNode | null) => void;
}

const HelpPopupContext = createContext<HelpPopupContextType | undefined>(
  undefined,
);

export const useHelpPopupContext = () => {
  const context = useContext(HelpPopupContext);
  if (context === undefined) {
    // This context is optional, so we don't throw an error if not found.
    // Components using it should handle the undefined case.
    return null;
  }
  return context;
};

interface HelpPopupProviderProps {
  children: ReactNode;
  onLinkChange: (linkElement: ReactNode | null) => void;
}

export const HelpPopupProvider: React.FC<HelpPopupProviderProps> = ({
  children,
  onLinkChange,
}) => {
  const value = { setExternalLink: onLinkChange };

  return (
    <HelpPopupContext.Provider value={value}>
      {children}
    </HelpPopupContext.Provider>
  );
};
